import { Component, ElementRef, EventEmitter, Input, OnInit} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TileService } from '../../../widgets/services/tile.service';
import { CommonModule, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalOptions } from '../../../widgets';


@Component({
  selector: 'app-home-video-modal',
  standalone:true,
  imports: [
    CommonModule,
    NgIf, FormsModule
  ],
  templateUrl: './home-video-modal.component.html',
  styleUrls: ['./home-video-modal.component.scss']
})
export class HomeVideoModalComponent implements OnInit {
  @Input() options: ModalOptions = new ModalOptions();
  @Input() params: any[] = [];
  videoUrl: any;
  closeVideoPopup = new EventEmitter<boolean>();
  constructor(private elementRef: ElementRef, public activeModal: NgbActiveModal, private tileService: TileService) {
  }

  async ngOnInit() {
    if (this.params[0] == "tipOfTheWeek") {
      this.getVideoUrl(this.params[0]);
      this.openVideo();
    }
    else if (this.params[0] == "feedback") {
      this.getVideoUrl(this.params[0]);
      this.openVideo();
    }
    else if (this.params[0] == "proposal") {
      this.getVideoUrl(this.params[0]);
      this.openVideo();
    }
    else if (this.params[0] == "DanskeBank") {
      this.getVideoUrl(this.params[0]);
      this.openVideo();
    }
    else if (this.params[0] == "VWStory") {
      this.getVideoUrl(this.params[0]);
      this.openVideo();
    }
    else if (this.params[0] == "ESStory") {
      this.getVideoUrl(this.params[0]);
      this.openVideo();
    }
    else if (this.params[0] == "Americas") {
      this.getVideoUrl(this.params[0]);
      this.openVideo();
    }
 
    this.elementRef.nativeElement.querySelector('.fa-regular')
      .addEventListener('click', this.closeVideo.bind(this));
    (document.getElementsByClassName("video-spinner")[0] as HTMLElement).style.display = "none";
  
  }
  openVideo() {
    var videoHTML = "<div style='position:relative;height:0;padding-bottom:54.332552693208434%'><iframe class='sproutvideo-player' src='" + this.videoUrl + "' style='position:absolute;width:100%;height:100%;left:0;top:0' frameborder='0' allowfullscreen referrerpolicy='no-referrer-when-downgrade' title='Video Player'></iframe></div>";
    (document.querySelector('#fsModalContent') as HTMLElement).innerHTML = "";
    var newdiv = document.createElement("div");
    newdiv.classList.add("popup-close");
    newdiv.innerHTML = "<div class='tile-button-close' style='text-align:right;'><i class='fa-regular fa-rectangle-xmark' style='color:#1e365c;'></i></div>";
    (document.querySelector('#fsModalContent') as HTMLElement).appendChild(newdiv);

    // Add content
    var newdiv2 = document.createElement("div");
    newdiv2.classList.add("video-content");
    newdiv2.innerHTML = videoHTML;
    (document.querySelector('#fsModalContent') as HTMLElement).appendChild(newdiv2);
    (document.querySelector('#fsModal') as HTMLElement).style.display = "block";
  }
  closeVideo(event:any) {
    this.activeModal.close('success');
  }

  getVideoUrl(videoDetails: string) {
    if (videoDetails == 'tipOfTheWeek') {
      this.videoUrl = 'https://videos.sproutvideo.com/embed/4d9fd8b01a14edc7c4/2a7bd799ccc417d9';
    }
    else if (videoDetails == 'feedback') {
      this.videoUrl = 'https://videos.sproutvideo.com/embed/799fd8b01a14ecc2f0/0edffb34eaaeed0e';
    }
    else if (videoDetails == 'proposal') {
      this.videoUrl = 'https://videos.sproutvideo.com/embed/709fdbba1117e3c9f9/1c498ad44fec6157';
    }
    else if (videoDetails == 'DanskeBank') {
      this.videoUrl = 'https://videos.sproutvideo.com/embed/ac90d0b51f1eeecc25/18bacf08374e5766';
    }
    else if (videoDetails == 'VWStory') {
      this.videoUrl = 'https://videos.sproutvideo.com/embed/1190d0b51f1eefc498/932c2f3feb32f835';
    }
    else if (videoDetails == 'ESStory') {
      this.videoUrl = 'https://videos.sproutvideo.com/embed/a790d7b5181ee5c02e/fa5d58e59ab1e3d7';
    }
    else if (videoDetails == 'Americas') {
      this.videoUrl = 'https://videos.sproutvideo.com/embed/7091d6b01314e5c7f9/d72f267d7c2e49f1';
    }
  }
}


